import { render, staticRenderFns } from "./Lgx243513689702461835.vue?vue&type=template&id=3f50ac2e&"
import script from "./Lgx243513689702461835.vue?vue&type=script&lang=js&"
export * from "./Lgx243513689702461835.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243513689702461835.vue?vue&type=style&index=0&id=3f50ac2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports